import { type PartnerRoutes } from "../../types/partnerRoutes"
import { Partner } from "../partner"

export const routes: Record<Partner, PartnerRoutes> = {
    [Partner.Darty]: [],
    [Partner.DartyOctopus]: [],
    [Partner.Effy]: [],
}
